// src/hooks/useHashAnchor.ts
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * 在 HashRouter 下实现锚点滚动
 * 支持 ScrollTrigger pinned section 内的锚点
 */
export function useHashAnchor() {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (!hash) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    const id = hash.replace('#', '');

    // 需要等 ScrollTrigger 初始化完成后再计算位置
    const timer = setTimeout(() => {
      const el = document.getElementById(id);
      if (!el) return;

      // 查找该元素是否在某个 pinned ScrollTrigger 内部
      const pinTrigger = ScrollTrigger.getAll().find(st => {
        const pin = st.pin;
        if (!pin) return false;
        return pin === el || pin.contains(el);
      });

      if (pinTrigger) {
        // 元素在 pinned section 内，需要计算 ScrollTrigger 的起始滚动位置
        // pinTrigger.start 就是 pin 开始时的 scroll 值
        // 对于首屏 pin 的 "企业介绍"，滚动到 pin 起点即可让用户看到该 section
        const scrollTarget = pinTrigger.start;
        window.scrollTo({ top: scrollTarget, behavior: 'smooth' });
      } else {
        // 普通元素，直接 scrollIntoView
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [location]);
}
